import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalName } from '../../../core/utils/global-name';
import { LocalStorageService } from '../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-task-list',
    templateUrl: './task-list.component.html',
    imports: [CommonModule],
    styleUrls: ['./task-list.component.css']
})
export class TaskListComponent {
@Input('loading') loading=false
@Input('data') data:any[]=[]
@Input('checkCanSet') checkCanSet:any
@Output() setStatusEmitter = new EventEmitter<any>();
@Output() editEmitter = new EventEmitter<any>();
@Output() deleteEmitter = new EventEmitter<any>();
@Output() confirmEmitter = new EventEmitter<any>();
user:any
role:any

constructor(private lsService:LocalStorageService){}

ngOnInit(){
   this.user=this.lsService.get(GlobalName.userName)
   this.role=this.user.roles[0].name
}

setStatus(value:any,id:any){
  return this.setStatusEmitter.emit({
    value:value,
    id:id
  })
}
edit(value:any){
  return this.editEmitter.emit(value)
}
delete(value:any){
  return this.deleteEmitter.emit(value)
}
confirm(value:any){
  return this.confirmEmitter.emit(value)
}

}
